import {nextNearestJs} from './next-nearest-js';

export function nextNearest(value: number, direction: number): number {
    return nextNearestJs(value, direction);
}